import React from 'react';
import { Page } from '../Page';
import { Bone, Shield, Sun } from 'lucide-react';
export function SupplementVitaminD() {
  return <Page pageNumber={15} variant="light" data-id="element-2660">
      <div className="flex h-full gap-10" data-id="element-2661">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2662">
          <img src="https://cdn.magicpatterns.com/uploads/f8crb1mnC4CRD44jU5PeSR/pasted-image.png" alt="Thorne Vitamin D3 5000 + K2" className="w-full max-w-[280px] object-contain" data-id="element-2663" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2664">
          <div className="mb-6 pt-4" data-id="element-2665">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2666">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2667">
              Vitamin D3 5000 + K2
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2668">
              Bone + immune support during rapid weight loss
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2669" />
          </div>

          <div className="mb-8" data-id="element-2670">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2671">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2672">
              Rapid weight loss increases the risk of bone density loss. Vitamin
              D3 supports calcium absorption and bone health, while K2 (MK-7)
              directs calcium to bones rather than arteries. Many adults are
              deficient, especially during winter months or with limited sun
              exposure.
            </p>
          </div>

          <div className="mb-8" data-id="element-2673">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2674">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2675">
              <li className="flex gap-2" data-id="element-2676">
                <Bone className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2677" />
                <span data-id="element-2678">
                  Supports bone density and strength during caloric deficit and
                  weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2679">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2680" />
                <span data-id="element-2681">
                  Enhances immune function (which can dip during rapid metabolic
                  change)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2682">
                <Sun className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2683" />
                <span data-id="element-2684">
                  K2 MK-7 ensures calcium goes to bones, not blood vessels,
                  critical for cardiovascular health
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2685">
                <span className="text-tealslate shrink-0" data-id="element-2686">•</span>
                <span data-id="element-2687">
                  125mcg (5000 IU) D3 per capsule, therapeutic dose for
                  deficiency correction
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2688">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2689">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2690">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2691">
                <strong data-id="element-2692">1 capsule daily</strong> with a meal containing fat
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2693">
                125mcg (5000 IU) Vitamin D3 + K2 MK-7 per capsule
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2694">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2695" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2696">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}